import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import { ErrorBoundary } from './components/ErrorBoundary';
import { AuthProvider } from './hooks/AuthContext';
import './index.css';

// Global error listeners to catch silent runtime errors
window.addEventListener('error', (e) => {
  // Suppress browser extension message errors
  if (e.message && e.message.includes('message channel closed')) {
    return;
  }
  console.error('🌋 window error:', e.error ?? e);
});
window.addEventListener('unhandledrejection', (e) => {
  // Suppress browser extension message errors
  if (e.reason && e.reason.message && e.reason.message.includes('message channel closed')) {
    return;
  }
  console.error('🌋 unhandledrejection:', e.reason ?? e);
});
console.log('🔔 Global error hooks installed');

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <AuthProvider>
        <App />
      </AuthProvider>
    </ErrorBoundary>
  </StrictMode>
);
